import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import numberArrayGenerator from 'number-array-generator';
import Helmet from 'react-helmet';
import * as _ from 'lodash';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import { Link } from 'react-router';
import Checkbox from 'material-ui/Checkbox';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import AutoComplete from 'material-ui/AutoComplete';
import Paper from 'material-ui/Paper';
import AdBlockDetect from 'react-ad-block-detect';
import { generateFacebookTargetingSpec } from '../../helpers/facebookAdTargeting';
import { initialLeadBuilderState, toRedux as convertFormToRedux } from '../../helpers/leadFormConverter';
import LeadFormBuilder from 'containers/AdBuilder/LeadFormBuilder';
import TimePicker from 'material-ui/TimePicker';
import { Tabs, Tab } from 'material-ui/Tabs';
import TextField from 'material-ui/TextField';
import { LLSelectField, LLTextField, LLCheckbox, LLChip, LLTextArea, LLRadioButton, LLRadioGroup, LLDropDownList, LLAutoCompleteField } from 'components/FormElements';
import { AudienceBuilder } from 'containers';
import { Accordion, AdStep2Preview, AudienceCard, ButtonBar, FormSection, PageHeader, MultiAccordionSection, SecondaryButton, Tooltip, CustomAudienceBuilder, EllipsisLoader } from 'components';
import AudiencePlacement from '../Ads/Audiences/AudiencePlacement';
import { connect } from 'react-redux';
import moment from 'moment';
import { fetchFormDetails, getAvailableAdFunds, changeAdBuilderValue, getPageConnectedInstagramAccount } from 'redux/modules/adBuilder';
import { changeField, clearForm, mergeForm, asyncChangeField } from 'redux/modules/forms';
import { changeConfigDataValue, clearAudience, createAudience, getReachEstimate, populateAudience } from 'redux/modules/audience';
import { getAudienceDefinition, loadSavedFacebookAudiences } from 'redux/modules/ads';
import { getSavedAudiencesWithDefinition } from 'redux/modules/adsAudiences';
import * as styles from './AdBuilder.scss';
import DatePicker from 'material-ui/DatePicker';
import ReactTooltip from 'react-tooltip';
import Measure from 'react-measure';
var AdStep2 = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  var leadBuilderForm = state.forms && state.forms["lead_builder_org_".concat(orgId)] ? _objectSpread({}, state.forms["lead_builder_org_".concat(orgId)]) : null;
  return {
    organization: state.organization.current,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    builder: leadBuilderForm,
    builderFormName: "lead_builder_org_".concat(orgId),
    formValues: state.adBuilder && state.adBuilder[orgId] ? _objectSpread({}, state.adBuilder[orgId]) : [],
    adType: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].type : '',
    targetingConfigData: state.audience && state.audience.FacebookTargetingConfig && state.audience.FacebookTargetingConfig.data ? state.audience.FacebookTargetingConfig.data : null,
    reachEstimate: state.audience.reachEstimate,
    audience: state.audience,
    targetingSentences: state.audience.targetingSentences,
    theme: state.theme,
    type: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].type : '',
    gettingSavedAudiences: state.adsAudiences.gettingSavedAudiences,
    savedAudiences: state.adsAudiences && state.adsAudiences.savedAudiences[orgId] ? state.adsAudiences.savedAudiences[orgId] : [],
    adAccountConnectedInstagramId: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].adAccountConnectedInstagramId : null,
    availableAdsFunds: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].availableAdsFunds : 0,
    fbAdPreviewError: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].fbAdPreviewError : null,
    creatingAudience: state.ads.creatingAudience,
    facebookPixels: state.ads.facebookPixels
  };
}, {
  changeField: changeField,
  clearForm: clearForm,
  fetchFormDetails: fetchFormDetails,
  mergeForm: mergeForm,
  asyncChangeField: asyncChangeField,
  changeConfigDataValue: changeConfigDataValue,
  clearAudience: clearAudience,
  createAudience: createAudience,
  getReachEstimate: getReachEstimate,
  getSavedAudiencesWithDefinition: getSavedAudiencesWithDefinition,
  populateAudience: populateAudience,
  getAudienceDefinition: getAudienceDefinition,
  loadSavedFacebookAudiences: loadSavedFacebookAudiences,
  getAvailableAdFunds: getAvailableAdFunds,
  changeAdBuilderValue: changeAdBuilderValue,
  getPageConnectedInstagramAccount: getPageConnectedInstagramAccount
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AdStep2, _Component);

  var _super = _createSuper(AdStep2);

  function AdStep2(props) {
    var _this;

    _classCallCheck(this, AdStep2);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getExistingForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props, builderFormName, orgId, socialAccountId;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, builderFormName = _this$props.builderFormName, orgId = _this$props.organization.id, socialAccountId = _this$props.adAccount.socialAccountId;
              _context2.prev = 1;

              _this.props.changeField(builderFormName, 'fetchingForms', true);

              _context2.next = 5;
              return _this.props.asyncChangeField(builderFormName, 'existingLeadForms', /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
                  var _yield$client$get, data;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return client.get("/org/".concat(orgId, "/socialAccount/").concat(socialAccountId, "/leadForms"));

                        case 2:
                          _yield$client$get = _context.sent;
                          data = _yield$client$get.data;
                          return _context.abrupt("return", data);

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());

            case 5:
              _this.props.changeField(builderFormName, 'fetchingForms', false);

              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              console.error(_context2.t0);

              _this.props.changeField(builderFormName, 'fetchingForms', false);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "canContinue", function () {
      var _this$props2 = _this.props,
          formValues = _this$props2.formValues,
          availableAdsFunds = _this$props2.availableAdsFunds;

      if (availableAdsFunds <= 0) {
        return {
          val: false,
          reason: 'You do not have enough ads funds for this ad.'
        };
      } else if (availableAdsFunds < parseFloat(formValues.adBudget ? formValues.adBudget : 0) * 100.0) {
        return {
          val: false,
          reason: 'You do not have enough ads funds for this ad.'
        };
      }

      if (!formValues['saved-audiences']) {
        return {
          val: false,
          reason: 'You have not selected a Saved Audience to use.'
        };
      }

      if (isNaN(parseInt(formValues.adBudget)) || parseInt(formValues.adBudget) <= 0) {
        return {
          val: false,
          reason: 'The budget for this ad is too low.'
        };
      }

      if (!formValues.adName) {
        return {
          val: false,
          reason: 'You must give your ad a name.'
        };
      }

      if (moment(formValues.adStart).isBefore(moment().startOf('hour')) || moment(formValues.adEnd).isBefore(moment(formValues.adStart)) || moment(formValues.adStart).isAfter(moment(formValues.adEnd)) || moment(formValues.adStart).isSame(moment(formValues.adEnd), 'day') || moment(formValues.adEnd).isSame(moment(formValues.adStart), 'day')) {
        return {
          val: false,
          reason: 'Your ad must be in the future and the end time must be later than the start time.'
        };
      }

      if (moment(formValues.adEnd).diff(moment(formValues.adStart), 'hours') < 24) {
        return {
          val: false,
          reason: 'Ads must run for a minimum of 24 hours.'
        };
      }

      if (formValues.minAdStart && formValues.minAdEnd) {
        if (moment(formValues.adStart).isBefore(moment(formValues.minAdStart)) || moment(formValues.adStart).isAfter(moment(formValues.maxAdEnd)) || moment(formValues.adEnd).isAfter(moment(formValues.maxAdEnd)) || moment(formValues.adEnd).isBefore(moment(formValues.minAdStart))) {
          return {
            val: false,
            reason: "Your ad must be later than ".concat(moment(formValues.minAdStart).format('MMM D, YYYY'), " and sooner than ").concat(moment(formValues.maxAdEnd).format('MMM D, YYYY'), ".")
          };
        }
      }

      if (moment(formValues.adEnd).diff(moment(formValues.adStart), 'minutes') * 2 / (24 * 60) > parseFloat(formValues.adBudget)) {
        return {
          val: false,
          reason: 'Ads require a minimum of $2/day. Reduce the number of days to run this ad.'
        };
      }

      return {
        val: true
      };
    });

    _defineProperty(_assertThisInitialized(_this), "showScheduleDatePicker", function () {
      var selectedTab = _this.state.scheduleTabs.find(function (tab) {
        return tab.selected;
      });

      return selectedTab && selectedTab.key === 'custom';
    });

    _defineProperty(_assertThisInitialized(_this), "budgetTypeChange", function (tab) {
      _this.tabChange(tab);

      _this.props.changeAdBuilderValue(_this.props.organization.id, {
        budgetType: tab.key
      });
    });

    _this.state = {
      showLeadFormBuilder: false,
      showAudienceDialog: false,
      audienceType: 'saved',
      budgetTabs: [{
        title: 'Daily',
        selected: true,
        key: 'daily',
        group: 'budget'
      }, {
        title: 'Lifetime',
        key: 'lifetime',
        group: 'budget'
      }],
      budgetType: 'daily',
      scheduleTabs: [{
        title: 'Set Times',
        selected: true,
        key: 'custom',
        group: 'schedule'
      }, {
        title: 'Continuous',
        key: 'continuous',
        group: 'schedule'
      }],
      scheduleType: 'custom'
    };
    return _this;
  }

  _createClass(AdStep2, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      console.log('in componentWillMount()');
      var formattedAdType;

      switch (this.props.type) {
        case 'pageLikes':
          formattedAdType = 'Page Like Ad';
          break;

        case 'clicksToWebsite':
          formattedAdType = 'Website Click Ad';
          break;

        case 'leadGeneration':
          formattedAdType = 'Lead Gen Ad';
          break;
      }

      if (!this.props.formValues.adName) {
        this.props.changeAdBuilderValue(this.props.organization.id, {
          adName: "".concat(formattedAdType, " - ").concat(moment().format('MMMM Do YYYY, h:mm A'))
        });
      }

      this.props.getPageConnectedInstagramAccount(this.props.organization.id, this.props.adAccount.socialAccountId);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      console.log('in componentDidMount()');
      this.props.getSavedAudiencesWithDefinition(this.props.organization.id, this.props.adAccount.adAccountId).then(function () {
        if (_this2.props.formValues['saved-audiences'] && _this2.props.formValues['saved-audiences'].id) {
          _this2.props.populateAudience(_this2.props.savedAudiences.find(function (e) {
            return e.id === _this2.props.formValues['saved-audiences'].id;
          }));
        } else if (_this2.props.savedAudiences && _this2.props.savedAudiences.length > 0) {
          _this2.props.populateAudience(_this2.props.savedAudiences[0]);
        }
      });
      this.props.getAvailableAdFunds(this.props.organization.id);
      this.getExistingForms();
    }
  }, {
    key: "render",
    value:
    /*
      RENDER
    */
    function render() {
      var _this3 = this;

      console.log('in render');
      var _this$props3 = this.props,
          organization = _this$props3.organization,
          theme = _this$props3.theme,
          formValues = _this$props3.formValues,
          adTypeText = _this$props3.adTypeText;

      if (!formValues) {
        // From JMW:
        // IMPORTANT
        // This needs to be here because there is a short delay in
        // switching routes from the tabs. This causes this render to be called
        // with the wrong organization id which makes the form values null.
        // Things freak out if this is not here.
        //
        return /*#__PURE__*/React.createElement("div", null);
      }

      var canContinue = this.canContinue();
      var savedAudienceList = [].concat(_toConsumableArray(this.props.savedAudiences ? this.props.savedAudiences.map(function (a) {
        return {
          id: a.id,
          title: a.name
        };
      }) : []), [this.props.formValues.reusedAdAudience ? {
        id: this.props.formValues.reusedAdAudience.id,
        title: this.props.formValues.reusedAdAudience.name
      } : null]).filter(function (a) {
        return a;
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, {
        title: "Ad Builder - Ad Settings"
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReactTooltip, null), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-sm-7 ".concat(styles.colXS6),
        style: {
          borderRight: '1px solid #f1f1f1',
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 140px)',
          overflow: 'hidden',
          overflowY: 'auto'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: adTypeText,
        secondary: "Settings",
        style: {
          marginBottom: 16
        }
      })), /*#__PURE__*/React.createElement(FormSection, {
        title: "Name"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        style: {
          width: '100%'
        },
        name: "adName",
        type: "text",
        label: "Name",
        className: "form-control",
        value: this.props.formValues.adName,
        onChange: function onChange(e) {
          _this3.props.changeAdBuilderValue(_this3.props.organization.id, {
            adName: e.target.value
          });
        }
      })), /*#__PURE__*/React.createElement(FormSection, {
        title: "Audience",
        style: {
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, this.props.gettingSavedAudiences && !this.props.savedAudiences.length ? /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#616161',
          marginBottom: 16
        }
      }, "Loading saved audiences", /*#__PURE__*/React.createElement(EllipsisLoader, null)) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: styles.audienceSelectText
      }, "Select an audience below:"), this.props.savedAudiences && !!this.props.savedAudiences.length || this.props.formValues.reusedAdAudience ? /*#__PURE__*/React.createElement(SelectField, {
        name: "saved-audiences",
        type: "dropdown",
        hintText: "Audience",
        className: "form-control",
        style: {
          width: '100%'
        },
        value: this.props.formValues['saved-audiences'] && this.props.formValues['saved-audiences'].id ? this.props.formValues['saved-audiences'].id : null,
        onChange: function onChange(event, index, value) {
          _this3.props.populateAudience(_this3.props.savedAudiences[index]);

          _this3.props.changeAdBuilderValue(_this3.props.organization.id, {
            'saved-audiences': {
              id: value,
              title: _this3.props.savedAudiences[index].name
            }
          });
        }
      }, this.props.savedAudiences.map(function (i, index) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: parseInt(i.id),
          primaryText: i.name,
          key: "savedMenuItem_".concat(index)
        });
      })) : /*#__PURE__*/React.createElement("p", null, "You do not have any Saved Audiences yet."))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-1 ".concat(styles.audienceOrText)
      }, "OR"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Create New Audience",
        onClick: function onClick() {
          _this3.props.clearAudience();

          _this3.setState({
            showAudienceDialog: true
          });
        }
      }))), this.props.type === 'leadGeneration' && /*#__PURE__*/React.createElement(FormSection, {
        title: "Lead Form",
        style: {
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, this.props.gettingSavedAudiences && !this.props.savedAudiences.length ? /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#616161',
          marginBottom: 16
        }
      }, "Loading lead forms", /*#__PURE__*/React.createElement(EllipsisLoader, null)) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: styles.audienceSelectText
      }, "Select a lead form below:"), this.props.builder && this.props.builder.existingLeadForms && !!this.props.builder.existingLeadForms.length || this.props.formValues.reusedAdAudience ? /*#__PURE__*/React.createElement(SelectField, {
        name: "existing-lead-forms",
        type: "dropdown",
        hintText: "Lead Form",
        className: "form-control",
        style: {
          width: '100%'
        },
        value: !!this.props.builder && this.props.builder.createdForm ? this.props.builder.createdForm.id : null,
        onChange: function onChange(event, index, value) {
          _this3.props.changeField(_this3.props.builderFormName, 'loadingRemoteForm', true);

          _this3.props.fetchFormDetails(_this3.props.organization.id, _this3.props.adAccount.socialAccountId, value).then(function (_ref3) {
            var data = _ref3.data;

            _this3.props.changeField(_this3.props.builderFormName, 'createdForm', {
              id: value
            });
          });
        }
      }, this.props.builder.existingLeadForms.map(function (i, index) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: i.id,
          primaryText: i.name,
          key: "savedMenuItem_".concat(index)
        });
      })) : /*#__PURE__*/React.createElement("p", null, "You do not have any Lead Forms yet."))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-1 ".concat(styles.audienceOrText)
      }, "OR"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Create New Lead Form",
        onClick: function onClick() {
          _this3.props.mergeForm(_this3.props.builderFormName, _objectSpread({}, initialLeadBuilderState(_this3.props.organization.id)));

          _this3.props.changeField(_this3.props.builderFormName, 'isCreatingNewForm', true);

          _this3.props.changeField(_this3.props.builderFormName, 'step', 1);

          _this3.setState({
            showLeadFormBuilder: true
          });
        }
      }))), /*#__PURE__*/React.createElement(FormSection, {
        title: "Placement"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          marginTop: 8,
          width: '100%'
        }
      }, this.props.formValues['saved-audiences'] && this.props.formValues['saved-audiences'].id ? /*#__PURE__*/React.createElement(AudiencePlacement, {
        adType: this.props.type,
        instagramConnected: this.props.adAccountConnectedInstagramId
      }) : /*#__PURE__*/React.createElement("span", {
        className: styles.audienceSelectText
      }, "Select an audience above before setting placement."))), /*#__PURE__*/React.createElement(FormSection, {
        title: "Lifetime Budget"
      }, /*#__PURE__*/React.createElement("div", {
        "data-tip": this.props.formValues.fromPlannedAd && !!this.props.formValues.fromPlannedAd.id ? 'To edit the budget for this ad, change it in your Ads Planner.' : null
      }, "$", /*#__PURE__*/React.createElement(LLTextField, {
        name: "adBudget",
        value: this.props.formValues.adBudget,
        disabled: this.props.formValues.fromPlannedAd && !!this.props.formValues.fromPlannedAd.id,
        onChange: function onChange(e) {
          _this3.props.changeAdBuilderValue(_this3.props.organization.id, {
            adBudget: e.target.value
          });
        },
        onBlur: function onBlur() {
          var fVal = parseFloat(_this3.props.formValues.adBudget);

          if (!isNaN(fVal)) {
            _this3.props.changeAdBuilderValue(_this3.props.organization.id, {
              adBudget: fVal
            });
          }
        }
      }))), /*#__PURE__*/React.createElement(FormSection, {
        title: "Schedule"
      }, this.showScheduleDatePicker() && /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement("p", {
        className: styles.adScheduleTitle
      }, "Start"), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, /*#__PURE__*/React.createElement(DatePicker, {
        firstDayOfWeek: 0,
        name: "adStart",
        fullWidth: true,
        formatDate: function formatDate(d) {
          return moment(d).format('MMM D, YYYY');
        },
        value: moment(this.props.formValues.adStart).toDate(),
        minDate: this.props.formValues.minAdStart ? moment(this.props.formValues.minAdStart).toDate() : undefined,
        maxDate: this.props.formValues.maxAdEnd ? moment(this.props.formValues.maxAdEnd).toDate() : undefined,
        onChange: function onChange(e, adStart) {
          return _this3.props.changeAdBuilderValue(_this3.props.organization.id, {
            adStart: moment(adStart).set({
              hour: moment(_this3.props.formValues.adStart).get('hour'),
              minute: moment(_this3.props.formValues.adStart).get('minute'),
              second: moment(_this3.props.formValues.adStart).get('second')
            })
          });
        },
        hintText: "Ad Start Date"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        fullWidth: true,
        pedantic: true,
        minuteStep: 5,
        hintText: "Ad Start Time",
        value: moment(this.props.formValues.adStart).toDate(),
        onChange: function onChange(e, adStart) {
          _this3.props.changeAdBuilderValue(_this3.props.organization.id, {
            adStart: adStart
          });
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement("p", {
        className: styles.adScheduleTitle
      }, "End"), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, /*#__PURE__*/React.createElement(DatePicker, {
        firstDayOfWeek: 0,
        fullWidth: true,
        name: "adEnd",
        formatDate: function formatDate(d) {
          return moment(d).format('MMM D, YYYY');
        },
        value: moment(this.props.formValues.adEnd).toDate(),
        minDate: this.props.formValues.minAdStart ? moment(this.props.formValues.minAdStart).toDate() : undefined,
        maxDate: this.props.formValues.maxAdEnd ? moment(this.props.formValues.maxAdEnd).toDate() : undefined,
        onChange: function onChange(e, adEnd) {
          return _this3.props.changeAdBuilderValue(_this3.props.organization.id, {
            adEnd: moment(adEnd).set({
              hour: moment(_this3.props.formValues.adEnd).get('hour'),
              minute: moment(_this3.props.formValues.adEnd).get('minute'),
              second: moment(_this3.props.formValues.adEnd).get('second')
            })
          });
        },
        hintText: "Ad End Date"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        fullWidth: true,
        pedantic: true,
        minuteStep: 5,
        hintText: "Ad End Time",
        value: moment(this.props.formValues.adEnd).toDate(),
        onChange: function onChange(e, adEnd) {
          _this3.props.changeAdBuilderValue(_this3.props.organization.id, {
            adEnd: adEnd
          });
        }
      }))))), !this.showScheduleDatePicker() && /*#__PURE__*/React.createElement("span", null, "Your ad will start today and run continuously")), !canContinue.val && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red',
          textAlign: 'right'
        }
      }, canContinue.reason), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Next",
        disabled: !canContinue.val,
        className: "".concat(styles.grayButton, " ").concat(styles.step2Button),
        onClick: function onClick() {
          browserHistory.push("/org/".concat(_this3.props.organization.id, "/create-ad/3"));
        }
      }), /*#__PURE__*/React.createElement(Link, {
        style: {
          marginRight: 24
        },
        className: "".concat(styles.grayButton, " ").concat(styles.step2Button),
        to: {
          pathname: !this.props.formValues.fromPlannedAd || !this.props.formValues.fromPlannedAd.id ? "/org/".concat(this.props.organization.id, "/create-ad/1") : "/org/".concat(this.props.organization.id, "/ads"),
          state: {
            modal: false
          }
        }
      }, "Back"))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-0 col-sm-5 ".concat(styles.colXS6),
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 140px)',
          overflow: 'hidden',
          overflowY: 'auto'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AdBlockDetect, null, /*#__PURE__*/React.createElement(Paper, {
        zDepth: 2,
        style: {
          borderRadius: 4,
          margin: '12px 0'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          borderRadius: '4px 0 0 4px',
          flex: '0 0 75px',
          flexDirection: 'column',
          backgroundColor: this.props.theme.colors.warningColor,
          display: 'flex',
          justifyContent: 'space-around'
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle",
        style: {
          color: 'white',
          fontSize: 20,
          width: '100%',
          textAlign: 'center'
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 12
        }
      }, /*#__PURE__*/React.createElement("h2", {
        style: {
          fontSize: 16,
          color: this.props.theme.colors.gray1
        }
      }, "Hmm...looks like your ad blocker is on."), /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: 12,
          color: this.props.theme.colors.gray1,
          lineHeight: '15px'
        }
      }, "Our Ad Builder tool might not work as expected when an ad blocker is enabled in your browser. Turn off your ad blocker or add this page's URL as an exception so you can create ads without any problems. After you turn off the ad blocker, you'll need to refresh your screen.")))))), /*#__PURE__*/React.createElement("div", null, formValues['saved-audiences'] && /*#__PURE__*/React.createElement(AudienceCard, {
        audience: {
          reachEstimate: this.props.reachEstimate,
          targetingSentences: this.props.targetingSentences,
          name: this.props.audience.name
        },
        colors: this.props.theme.colors
      }))))), /*#__PURE__*/React.createElement(Dialog, {
        autoScrollBodyContent: true,
        title: "Create An Audience",
        open: this.state.showAudienceDialog,
        contentStyle: {
          width: '85%',
          maxWidth: 100000
        },
        modal: true,
        onRequestClose: function onRequestClose() {
          _this3.setState({
            showAudienceDialog: false
          });
        },
        actions: [/*#__PURE__*/React.createElement(RaisedButton, {
          label: "Cancel",
          onClick: function onClick() {
            _this3.setState({
              showAudienceDialog: false
            }, function () {
              // TODO should this be populateAudience instead with saved-audience selected?
              _this3.props.clearAudience();
            });
          },
          style: {
            marginRight: 24
          }
        }), /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          label: "Save",
          disabled: this.props.audience.creatingAudience || !this.props.audience.name || this.props.audience.name === '',
          onClick: function onClick() {
            _this3.props.createAudience(_this3.props.organization.id, _this3.props.audience.name, _this3.props.audience.FacebookTargetingConfig.data, _this3.props.reachEstimate, _this3.props.targetingSentences).then(function (res) {
              _this3.setState({
                showAudienceDialog: false
              });

              _this3.props.populateAudience(_objectSpread(_objectSpread({}, res.data), {}, {
                reachEstimate: _this3.props.reachEstimate,
                targetingSentences: _this3.props.targetingSentences
              }));

              _this3.props.changeAdBuilderValue(_this3.props.organization.id, {
                'saved-audiences': {
                  id: res.data.id,
                  title: _this3.props.audience.name
                }
              });
            });
          }
        })]
      }, /*#__PURE__*/React.createElement(Measure, {
        onMeasure: function onMeasure(dimensions) {
          _this3.setState({
            audienceModalDimensions: dimensions
          });
        },
        whitelist: ['width', 'height'],
        useClone: true
      }, /*#__PURE__*/React.createElement(AudienceBuilder, {
        showSaveButton: false
      }))), /*#__PURE__*/React.createElement(Dialog, {
        autoScrollBodyContent: true,
        title: "Create a Lead Form",
        modal: true,
        open: this.state.showLeadFormBuilder,
        onRequestClose: function onRequestClose() {
          _this3.setState({
            showLeadFormBuilder: false
          });
        },
        actionsContainerStyle: {
          padding: 12
        },
        bodyStyle: {
          padding: 0
        },
        contentStyle: {
          maxWidth: 1200,
          width: '97%'
        },
        actions: [/*#__PURE__*/React.createElement(RaisedButton, {
          label: "Cancel",
          onClick: function onClick() {
            return _this3.setState({
              showLeadFormBuilder: false
            });
          }
        })]
      }, /*#__PURE__*/React.createElement(LeadFormBuilder, {
        onCreated: function onCreated(leadForm) {
          _this3.props.changeField(_this3.props.builderFormName, 'existingLeadForms', [leadForm].concat(_toConsumableArray(_this3.props.builder.existingLeadForms)));

          _this3.setState({
            showLeadFormBuilder: false
          });
        }
      })));
    }
  }]);

  return AdStep2;
}(Component), _defineProperty(_class2, "propTypes", {
  organization: PropTypes.object.isRequired
}), _temp)) || _class);
export default AdStep2;